<dropdown
        [buttonText]="disabled ? loadingCallListsButtonText : buttonText"
        [options]="options"
        [disabled]="disabled"
        (onSelect)="onValueSelect($event)"></dropdown>
